<template>

      <div class="card"  v-bind="{...$attrs}">
           <slot>

          </slot>
         <h2>
             <div>
                    <span class="title">
                        {{cardData.taxCompanyName}}
                    </span>
             <span class="key">{{cardData.taxPart}}</span>
               <span class="key">{{cardData.taxReportStatus |bspTableFilter({'1':'dict', '2':dicts})}}</span>
             <span class="key">{{cardData.declareType}}</span>
             </div>
             <!-- <div v-if="cardData.state==0">
                 <img src="@/assets/img/salary/fafang.png">
                <span>发放中</span>
             </div>
               <div v-if="cardData.state==1">
                 <img src="@/assets/img/salary/fafangwancheng-xiao.png">
                 <span>发放完成</span>
             </div>-->
                <div v-if="cardData.taxReportTime">
                 <span style="color:#666">{{cardData.taxReportTime}}</span>
             </div>

         </h2>
         <div class="carContent">
             <p v-if="cardData.taxType" class="type">报税类型包含：<span>{{cardData.taxType}}</span></p>
             <ul>
                 <li v-for="(label,i) in labels" >
                     <span>{{label}}：</span>
                     <span><img src="@/assets/img/salary/yiwen.png" v-if="i==4" style="vertical-align: middle;margin-right:10px;"/>{{cardData[keys[i]]}}</span>
                 </li>
             </ul>

         </div>
        <!-- <div class="info" v-if="cardData.state==1">
                 <div>
                     <img src="@/assets/img/salary/fafangwancheng-xiao.png" style="margin-left:0;" />
                     <span>发放完成：</span>
                     <span>{{cardData.grantInfo.num1}}人</span>
                 </div>
                  <div>
                     <img src="@/assets/img/salary/icon-bufa.png" />
                     <span>不发：</span>
                     <span>{{cardData.grantInfo.num2}}人</span>
                      <span style="margin-left:18px;">暂缓发放：</span>
                     <span>{{cardData.grantInfo.num2}}人</span>
                 </div>
                  <div v-if="cardData.grantInfo.num4">
                     <img src="@/assets/img/salary/icon-tuipiao.png" />
                     <span>退票：</span>
                     <span>{{cardData.grantInfo.num4}}人，请及时处理</span>
                 </div>
             </div>     -->

      </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import store from "@/store";
  export default {
    name: "card",
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    props: {
        cardData: {
            type: Object,
            default: {},
        },
        radio:{
            type: String,
            default: '1',
        },
        labels:{
             type: Array,
            default: [],
        },
         keys:{
             type: Array,
            default: [],
        }
    },
    data() {
      return {
         form:{
             radio:'1',
             adv:''
         }
      };
    },
    methods: {

    }
  };
</script>

<style scoped >
.card{
    box-shadow:0px 1px 5px 0px rgba(203,201,201,0.5);
    border-radius:4px;
    box-sizing:border-box;
    width:calc(33.3% - 10px);
    margin-right: 10px;
    margin-bottom: 10px;
    min-height: 233px;
    background: #fff;
    position: relative;
    overflow: hidden;
}
.type{
font-size:13px;
font-weight:400;
color:rgba(51,51,51,1);
line-height:18px;
padding:10px 0 20px;
}
.type>span{
    font-size:12px;
font-weight:400;
color:rgba(102,102,102,1);
line-height:17px;
}
    h2{
        height:22px;
        line-height:22px;
        border-bottom: 4px solid #F3F3F3;
        padding: 16px 14px 16px 20px;
        display:flex;
            justify-content: space-between;
    }
    h2>div>span{
            vertical-align: middle;
    }
    h2>div:nth-of-type(2)>span{
        font-size:13px;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding-left:10px;
    }
    .title{
        font-size:16px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:22px;
         margin-right:8px;
    }
    h2>div>.key{
        border-radius:2px;
        padding:1px 4px;
        font-size:10px;
        font-weight:300;
        line-height:14px;
        margin-left:5px;
    }
    h2>div>.key:nth-of-type(2){
        border:1px solid rgba(255,0,0,1);
        color:rgba(255,0,0,1)
    }
       h2>div>.key:nth-of-type(3){
        border:1px solid rgba(1,167,59,1);
        color:rgba(1,167,59,1);
    }
      h2>div>.key:nth-of-type(4){
        border:1px solid #E8E8E8;
        background:#E8E8E8;
    }

    .carContent{
        padding:15px 100px 15px 21px;
    }
    .carContent li{
        height:25px;
        line-height:25px;
        background:rgba(240,240,240,1);
        border-radius:4px;
        margin-bottom:5px;
        display:flex;
        justify-content: space-between;
           align-items: center;
    }
    .carContent li span:nth-of-type(1){
    font-size:13px;
font-weight:400;
color:rgba(51,51,51,1);
line-height:18px;
padding-left:10px;
display:inline-block;
width:65px;
text-align:right;

    }

        .carContent li span:nth-of-type(2){
                font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding-right:20px;

    }
    .info{
          display:flex;
          padding-left:25px;
          align-items: center;
    }
     .info>div{
         height:24px;
         line-height:24px;
     }
    .info span{
        font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:#666;
line-height:18px;
    vertical-align: middle;
    }
    .info img{
  vertical-align: middle;
  margin-right:9px;
  margin-left:30px;
    }


</style>
